import { Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { UsersComponent } from './sections/users/users.component';
import { WebhooksComponent } from './sections/webhooks/webhooks.component';
import { GeneralComponent } from './sections/general/general.component';
import { MessageTemplatesComponent } from './sections/message-templates/message-templates.component';
import { WorkflowsComponent } from './sections/workflows/workflows.component';
import { ConversationTypesComponent } from './sections/conversation-types/conversation-types.component';
import { ApiKeysComponent } from './sections/api-keys/api-keys.component';
import { ThemeComponent } from './sections/theme/theme.component';

export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      { path: '', redirectTo: 'general', pathMatch: 'full' },
      { path: 'general', component: GeneralComponent },
      { path: 'users', component: UsersComponent },
      { path: 'webhooks', component: WebhooksComponent },
      { path: 'message-templates', component: MessageTemplatesComponent },
      { path: 'workflows', component: WorkflowsComponent },
      { path: 'conversation-types', component: ConversationTypesComponent },
      { path: 'theme-colors', component: ThemeComponent },
      { path: 'api-keys', component: ApiKeysComponent },
    ],
  },
];
